import deDE from '@rover/app/locale/de-de/countries.json';
import esES from '@rover/app/locale/es-es/countries.json';
import frCA from '@rover/app/locale/fr-ca/countries.json';
import frFR from '@rover/app/locale/fr-fr/countries.json';
import itIT from '@rover/app/locale/it-it/countries.json';
import nbNO from '@rover/app/locale/nb-no/countries.json';
import nlNL from '@rover/app/locale/nl-nl/countries.json';
import svSE from '@rover/app/locale/sv-se/countries.json';
import allCountries from '@rover/constants/src/geography/countries.constants.json';
import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { DEFAULT_LOCALE } from '@rover/constants/src/i18n/locale';
import { ACTIVE_COUNTRY_CODES } from '@rover/utilities/roverGeo.constants';

const LOCALE_COUNTRIES: Partial<Record<Locale, Record<string, string>>> = {
  [Locale.DeDe]: deDE as Record<string, string>,
  [Locale.EsEs]: esES as Record<string, string>,
  [Locale.FrCa]: frCA as Record<string, string>,
  [Locale.FrFr]: frFR as Record<string, string>,
  [Locale.ItIt]: itIT as Record<string, string>,
  [Locale.NbNo]: nbNO as Record<string, string>,
  [Locale.NlNl]: nlNL as Record<string, string>,
  [Locale.SvSe]: svSE as Record<string, string>,
};

export const getLocalizedCountries = async (locale: Locale): Promise<Record<string, string>> => {
  if (locale === DEFAULT_LOCALE) {
    return {};
  }
  return LOCALE_COUNTRIES[locale] ?? {};
};

/**
 * Get country options for a select field, filtered to only include countries where Rover operates
 * Uses localized country names when available
 */
export const getCountryOptions = async (
  locale: Locale = DEFAULT_LOCALE
): Promise<Array<{ value: string; label: string }>> => {
  const localizedCountries = await getLocalizedCountries(locale);

  // Filter to only countries where Rover operates
  const roverCountries = allCountries.filter((country) =>
    ACTIVE_COUNTRY_CODES.includes(country.code as (typeof ACTIVE_COUNTRY_CODES)[number])
  );

  // Map to select field options, using localized names when available
  return roverCountries.map((country) => ({
    value: country.code,
    label: localizedCountries[country.code.toLowerCase()] || country.name,
  }));
};
